<template>
  <div class="consult-inner-page-container" ref="container">
    <div class="bg" v-if="$slots.bg">
      <slot name="bg" />
    </div>
    <img :src="teacher.avatar | blur" class="bg" v-if="teacher && !$slots.bg" />
    <div class="before-mask" v-if="!$slots.bg" />
    <div class="consult-inner-page-container-content">
      <navbar
        v-if="showNav"
        :showTitle="true"
        :fixed="true"
        :shareConfig="shareConfig"
        :headerFix="headerFix"
        :show="showNavbar"
        :class="{
          'scroll-leave-top': showHeaderCenter
        }"
        :color="color"
        :searchPlaceholder="searchPlaceholder"
        :showHeaderCenter="showHeaderCenter"
        :isShowSearch="isShowSearch"
        :isServicesIcon="isServicesIcon"
        @search="$emit('search')"
        @share="$emit('share')"
        @toServices="$emit('toServices')"
        ref="navbar"
      >
        <slot name="navbar"> </slot>
        <div
          class="context"
          v-if="title"
          :style="{
            opacity: showHeaderCenter ? 1 : 0
          }"
        >
          {{ title }}
        </div>
        <div
          class="navbar-teacher-info"
          v-if="teacher"
          @click="toTop"
          :style="{
            opacity: showHeaderCenter ? 1 : 0
          }"
        >
          <div class="avatar">
            <img :src="teacher.avatar | imgZip(150)" />
          </div>
          <div class="context">
            <p class="teacher-name">{{ teacher.name }}</p>
            <p class="times" v-if="teacher.total_num">
              {{ teacher.total_num }} 条评价
            </p>
            <p class="times" v-else-if="teacher.zx_num">
              {{ teacher.zx_num }} 人次咨询
            </p>
          </div>
        </div>
        <div
          class="navbar-bg"
          :style="{
            opacity: showHeaderCenter ? 1 : 0,
            position: 'absolute'
          }"
          slot="fixed-slot"
        >
          <slot name="bg" />
          <img
            v-if="teacher && !$slots.bg"
            :src="teacher.avatar | blur"
            class="bg"
            style="position: absolute"
          />
          <div
            class="before-mask"
            style="position: absolute"
            v-if="teacher && !$slots.bg"
          />
        </div>
      </navbar>
      <slot />
      <div class="consult-inner-page-radius-container" v-if="$slots.radius">
        <slot name="radius" />
        <div class="common-list-status-container" v-if="loadmore">
          <slot name="none" v-if="$slots.none && loadmore" />
          <listStatus :loadingEnd="!loadend" v-else />
        </div>
      </div>
      <div class="common-list-status-container" v-else-if="loadmore">
        <slot name="none" v-if="$slots.none && loadmore" />
        <listStatus :loadingEnd="!loadend" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { getScrollTop } from 'lib/tools/utils.js'
import navbar from 'component/consult/navbar'
import listStatus from 'component/common/listStatus'
// 为了避免嵌套一层 影响seo，需要子元素都定位才不会被遮盖
export default {
  components: {
    navbar,
    listStatus
  },

  props: {
    showNav: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    teacher: {
      type: Object
    },
    loadmore: {
      type: Boolean,
      default: false
    },
    headerFix: {
      type: Boolean,
      default: false
    },
    shareConfig: {
      type: Object,
      default() {
        return this.$isServer ? {} : this.$parent.shareConfig
      }
    },
    showNavbar: {
      type: Boolean,
      default: undefined
    },
    isShowSearch: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      defualt: ''
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    isServicesIcon: {
      type: String,
      default: ''
    }
  },

  filters: {
    blur(img) {
      if (!img) return img
      img = img.replace('!120', '')
      return (
        img.split('?')[0] + `?x-oss-process=image/resize,w_200/blur,r_30,s_30`
      )
    }
  },

  data() {
    return {
      showHeaderCenter: false,
      loading: false,
      loadend: false
    }
  },

  methods: {
    _scroll() {
      const st = getScrollTop()

      if (this.$listeners.scroll) {
        this.$emit('scroll', st)
      }

      this.showHeaderCenter = st > 100
      if (!this.loadmore) return

      clearTimeout(this.scrollEndTimer)
      this.scrollEndTimer = setTimeout(() => {
        if (this.loadmore) {
          const bodyH = this.$refs['container'].scrollHeight
          const winH = window.offsetHeight || window.screen.availHeight
          // 太快加载下面那个动画看不到了...
          if (bodyH - st - winH <= 1 && !this.loading && !this.loadend) {
            this._loadmore()
          }
        }
      }, 60)
    },

    _loadmore() {
      this.loading = true
      this.$emit('loadmore', res => {
        this.loading = false
        if (res && res.length === 0) {
          this.loadend = true
        }
      })
    },

    loadEnd() {
      this.loadend = true
    },

    refresh() {
      this.loading = false
      this.loadend = false
    },

    toTop() {
      window.scrollTo(0, 0)
      this.isHideServices = false
    },

    // 对外暴露，需保留
    getNavHeight() {
      return this.$refs['navbar']?.getHeight() || 0
    }
  },

  mounted() {
    this.$bridge.setStatusBarStyle({ style: 1 })

    this.$bridge.isPullRefreshEnable({
      enable: 0
    })
    window.addEventListener('scroll', this._scroll)
    this.$bridge.hasNotch().then(({ statusBarHeight }) => {
      this.$emit('statusBarHeight', statusBarHeight)
    })
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this._scroll)
  }
}
</script>

<style lang="scss">
.consult-inner-page-container {
  position: relative;
  width: 750px;
  min-height: 100%;

  .consult-inner-page-radius-container {
    background: #fff;
    border-radius: 30px;
    // overflow: hidden;
    position: relative;
  }

  &-content {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .before-mask {
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    width: 750px;
    margin-left: -375px;
    left: 50%;
    top: 0;
    height: 100%;
    content: '';
  }

  .bg {
    width: 750px;
    height: 100vh;
    position: fixed;
    left: 50%;
    margin-left: -375px;
    top: 0;
    object-fit: cover;
  }

  .navbar-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    background: #ffa202;
    overflow: hidden;
    left: 0;
    top: 0;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .navbar-teacher-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #fff;
    flex: 1;
    .avatar {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;
      }
    }
    .teacher-name {
      font-size: 26px;
      color: #ffffff;
      font-weight: bold;
      line-height: 26px;
      padding-top: 3px;
    }
    .times {
      font-size: 20px;
      color: #ffffff;
      padding-top: 8px;
      line-height: 20px;
    }
  }

  .common-list-status-container {
    // background: #ffffff;
    padding-top: 14px;
    padding-bottom: 55px;
    .common-list-status {
      margin: 0;
    }
  }
  .preview-content-box {
    padding: 0 30px pxToRem(100);
    min-height: 900px;
    .ensure-floor-preview {
      background: transparent url(../../../images/consult/expert/bg-baozhan.png)
        no-repeat center / 100% 100% !important;
      border-radius: 32px !important;
      height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      padding-left: 100px;
      .icon-m-right {
        color: #998a7a;
        font-size: 22px;
        position: absolute;
        right: 24px;
        font-weight: bold;
        top: 50%;
        transform: translateY(-50%);
      }

      .title {
        opacity: 0.7;
        font-size: 36px;
        color: #000000;
        line-height: 36px;
        font-weight: bold;
      }

      .desc {
        opacity: 0.4;
        font-size: 22px;
        padding-top: 20px;
        color: #000000;
        line-height: 24px;

        span {
          padding: 0 6px;
        }
      }
    }
    .submit-btn {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 10rem;
      height: 108px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      padding: 14px 40px;
      box-sizing: border-box;
      span {
        width: 315px;
        height: 80px;
        border: 2px solid #6982fa;
        border-radius: 40px;
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #6982fa;
        text-align: center;
        line-height: pxToRem(82);
        &:last-of-type {
          background: #6982fa;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
